import { render, staticRenderFns } from "./CmsUsp.vue?vue&type=template&id=51504e67&scoped=true&"
import script from "./CmsUsp.vue?vue&type=script&lang=js&"
export * from "./CmsUsp.vue?vue&type=script&lang=js&"
import style0 from "./CmsUsp.vue?vue&type=style&index=0&id=51504e67&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51504e67",
  null
  
)

export default component.exports